import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getLogin } from "../../../features/userSlice";
import MainModal from "../../modals/MainModal";
import { GetContactAsync } from "../../../features/ContactSlice";

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const contactData = useSelector((state) => state.contact.contactData);
  const [path, setPath] = useState("");
  const [isClicked, setIsClicked] = useState(false);

  const [show, setShow] = useState(false);
  const [modal, setModal] = useState("login");

  const login = useSelector(getLogin);

  React.useEffect(() => {
    dispatch(GetContactAsync());
    if (Object.keys(login).length > 0 && isClicked) {
      navigate({
        pathname: path,
      });
    } else if (isClicked) {
      setModal("login");
      setShow(true);
    }
    setIsClicked(false);
  }, [login, isClicked]);

  const handleLogin = (val) => {
    // navigate(val);
    setIsClicked(true);
    setPath(val);
  };

  return (
    <>
      <footer>
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="footer-wrap first-footer-wrap">
                <div className="footer-logo">
                  <Link href="#">
                    <img src="assets/images/logo.png" alt="logo2" />
                  </Link>
                </div>
                <div className="footer-title">
                  <h4 className="wtext">Follow Us On</h4>
                  <div className="social-links">
                    <a target="_blank" href={contactData?.facebookLink}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="18"
                        viewBox="0 0 10 18"
                        fill="none"
                      >
                        <path
                          d="M6.06494 17.997V9.80099H8.82994L9.24094 6.59199H6.06494V4.54799C6.06494 3.62199 6.32294 2.98799 7.65194 2.98799H9.33594V0.126986C8.51658 0.0391771 7.69299 -0.00322112 6.86894 -1.39392e-05C4.42494 -1.39392e-05 2.74694 1.49199 2.74694 4.23099V6.58599H-6.10352e-05V9.79499H2.75294V17.997H6.06494Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                    <a target="_blank" href={contactData?.insttaLink}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M18.947 6.30502C18.9369 5.54764 18.7951 4.79779 18.528 4.08902C18.2964 3.49117 17.9425 2.94822 17.4892 2.49485C17.0358 2.04148 16.4929 1.68767 15.895 1.45602C15.1953 1.19338 14.4562 1.05136 13.709 1.03602C12.747 0.993018 12.442 0.981018 10 0.981018C7.55801 0.981018 7.24501 0.981018 6.29001 1.03602C5.54317 1.05147 4.80436 1.19349 4.10501 1.45602C3.50707 1.68751 2.96403 2.04126 2.51064 2.49465C2.05725 2.94804 1.7035 3.49108 1.47201 4.08902C1.20884 4.78815 1.06713 5.52713 1.05301 6.27402C1.01001 7.23702 0.997009 7.54202 0.997009 9.98402C0.997009 12.426 0.997009 12.738 1.05301 13.694C1.06801 14.442 1.20901 15.18 1.47201 15.881C1.70389 16.4788 2.05791 17.0216 2.51145 17.4748C2.96499 17.928 3.50807 18.2816 4.10601 18.513C4.80344 18.7862 5.54238 18.9384 6.29101 18.963C7.25401 19.006 7.55901 19.019 10.001 19.019C12.443 19.019 12.756 19.019 13.711 18.963C14.4582 18.9483 15.1974 18.8066 15.897 18.544C16.4947 18.3121 17.0375 17.9582 17.4909 17.5049C17.9442 17.0515 18.2981 16.5087 18.53 15.911C18.793 15.211 18.934 14.473 18.949 13.724C18.992 12.762 19.005 12.457 19.005 10.014C19.003 7.57202 19.003 7.26202 18.947 6.30502ZM9.99401 14.602C7.44001 14.602 5.37101 12.533 5.37101 9.97902C5.37101 7.42502 7.44001 5.35602 9.99401 5.35602C11.2201 5.35602 12.396 5.84308 13.263 6.71006C14.1299 7.57704 14.617 8.75292 14.617 9.97902C14.617 11.2051 14.1299 12.381 13.263 13.248C12.396 14.115 11.2201 14.602 9.99401 14.602ZM14.801 6.26302C14.204 6.26302 13.723 5.78102 13.723 5.18502C13.723 5.04352 13.7509 4.90341 13.805 4.77268C13.8592 4.64195 13.9385 4.52317 14.0386 4.42311C14.1387 4.32306 14.2574 4.24369 14.3882 4.18954C14.5189 4.13539 14.659 4.10752 14.8005 4.10752C14.942 4.10752 15.0821 4.13539 15.2129 4.18954C15.3436 4.24369 15.4624 4.32306 15.5624 4.42311C15.6625 4.52317 15.7418 4.64195 15.796 4.77268C15.8501 4.90341 15.878 5.04352 15.878 5.18502C15.878 5.78102 15.396 6.26302 14.801 6.26302Z"
                          fill="currentColor"
                        />
                        <path
                          d="M9.99403 12.982C11.6525 12.982 12.997 11.6375 12.997 9.97901C12.997 8.3205 11.6525 6.97601 9.99403 6.97601C8.33552 6.97601 6.99103 8.3205 6.99103 9.97901C6.99103 11.6375 8.33552 12.982 9.99403 12.982Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                    <a target="_blank" href={contactData?.twitterLink}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                      >
                        <path
                          d="M17.9648 1.6672C17.301 1.94638 16.5923 2.13657 15.8461 2.22341C16.6066 1.7849 17.1915 1.09376 17.4683 0.269134C16.7551 0.667453 15.9646 0.9574 15.1231 1.11888C14.4511 0.430615 13.4934 0 12.43 0C10.3923 0 8.74014 1.58107 8.74014 3.52889C8.74014 3.80879 8.77388 4.07792 8.83538 4.33557C5.76801 4.19706 3.04937 2.78751 1.22995 0.656687C0.909712 1.17486 0.73047 1.777 0.73047 2.43297C0.73047 3.66022 1.38294 4.73891 2.3714 5.37264C1.76618 5.35398 1.19695 5.19465 0.700471 4.93054V4.97432C0.700471 6.68601 1.97017 8.1135 3.65985 8.43861C3.35011 8.51828 3.02312 8.56134 2.68789 8.56134C2.4524 8.56134 2.22666 8.53981 2.00092 8.49962C2.47415 9.90127 3.83459 10.9233 5.45377 10.952C4.19382 11.8986 2.59714 12.4627 0.877463 12.4627C0.584976 12.4627 0.293238 12.4462 0 12.4146C1.64168 13.4151 3.57585 14 5.66751 14C12.4577 14 16.1663 8.62019 16.1663 3.96237C16.1663 3.81238 16.1663 3.66094 16.1551 3.51023C16.8758 3.01574 17.505 2.39063 18 1.68155L17.9648 1.6672Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="app-download footer-title">
                  <h4 className="wtext">Download our Mobile Apps</h4>
                  <a target="_blank" href={contactData?.iosAppLink}>
                    <img
                      src="assets/images/app-store.png"
                      className="me-3"
                      alt="app-store"
                    />
                  </a>
                  <a target="_blank" href={contactData?.androidAppLink}>
                    <img
                      src="assets/images/Google_Play_Store.png"
                      className="me-3"
                      alt="Google_Play_Store"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="footer-wrap">
                <div className="footer-title">
                  <h4 className="wtext">Quick Links</h4>
                </div>
                <ul className="footer-lists">
                  <li>
                    <Link to={"/hotel"} className="wtext">
                      Hotel
                    </Link>
                  </li>
                  <li>
                    <Link to={"/flight"} className="wtext">
                      Flight
                    </Link>
                  </li>
                  <li>
                    <Link to={"/transfer"} className="wtext">
                      Transfer
                    </Link>
                  </li>
                  <li>
                    <Link to={"/carrent"} className="wtext">
                      Car Rental
                    </Link>
                  </li>
                  <li>
                    <Link to={"/sight"} className="wtext">
                      Sight seeing
                    </Link>
                  </li>
                  <li onClick={() => handleLogin("/visa")}>
                    <Link to={window.location.pathname} className="wtext">
                      Dubai Visa
                    </Link>
                  </li>
                  <li onClick={() => handleLogin("/insurance")}>
                    <Link to={window.location.pathname} className="wtext">
                      Insurance
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer-wrap">
                <div className="footer-title">
                  <h4 className="wtext">Company</h4>
                </div>
                <ul className="footer-lists">
                  <li>
                    <Link to={"/about"} className="wtext">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to={"/privacy"} className="wtext">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to={"/privacy"} className="wtext">
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to={"/contact"} className="wtext">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer-wrap">
                <div className="footer-title">
                  <h4 className="wtext">Features</h4>
                </div>
                <ul className="footer-lists">
                  {!Object.keys(login).length > 0 && (
                    <li>
                      {/*<a onClick={()=>handleLogin(window.location.pathname)} className="wtext">
                  </a>
                  */}
                    </li>
                  )}
                  <li>
                    <Link href="#" className="wtext">
                      Mobile App
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="copyright-text">
                <div className="copyright-wrap">
                  <p className="wtext">
                    © 2025 <span>Voyasia</span>. All rights reserved.
                  </p>
                  <p className="wtext made-with">
                    Made with <span className="heart">♥</span> for travelers
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {show ? (
        <MainModal
          modal={modal}
          setShow={setShow}
          show={show}
          setModal={setModal}
          // extraData={setIsClicked}
        />
      ) : null}
    </>
  );
};

export default Footer;
